import * as yup from 'yup';
import {
  STATUS_AUTHORIZED,
  STATUS_REFUSED,
  STATUS_SETTLED,
  STATUS_CANCELLED,
  STATUS_REFUNDED,
  STATUS_PARTIALLY_REFUNDED,
  STATUS_FAILED,
  STATUS_EXPIRED,
  STATUS_PENDING,
} from './helpers';
import {
  amountSchema,
  riskScoreSchema,
  multiSelectValidation,
} from 'components/PaymentFilter/defaultFilters.schema';

export const FIELD_NAMES = {
  statusCheckbox: 'statusCheckbox',
  amountCheckbox: 'amountCheckbox',
  fraudCheckbox: 'fraudCheckbox',

  [STATUS_AUTHORIZED]: STATUS_AUTHORIZED,
  [STATUS_CANCELLED]: STATUS_CANCELLED,
  [STATUS_EXPIRED]: STATUS_EXPIRED,
  [STATUS_FAILED]: STATUS_FAILED,
  [STATUS_PARTIALLY_REFUNDED]: STATUS_PARTIALLY_REFUNDED,
  [STATUS_PENDING]: STATUS_PENDING,
  [STATUS_REFUNDED]: STATUS_REFUNDED,
  [STATUS_REFUSED]: STATUS_REFUSED,
  [STATUS_SETTLED]: STATUS_SETTLED,

  fraud_score_min: 'fraud_score_min',
  fraud_score_max: 'fraud_score_max',

  amount_filter: 'amount_filter',
  amount: 'amount',
};
export const defaultValues = (currentFilters) => {
  const statusFilters = currentFilters.status
    ? new Set(currentFilters.status.split(','))
    : new Set();
  const defaultStatus = (fieldName) =>
    statusFilters.has(fieldName) ? true : false;

  return {
    [FIELD_NAMES.statusCheckbox]: currentFilters.statusCheckbox,
    status: {
      [STATUS_AUTHORIZED]: defaultStatus(STATUS_AUTHORIZED),
      [STATUS_CANCELLED]: defaultStatus(STATUS_CANCELLED),
      [STATUS_EXPIRED]: defaultStatus(STATUS_EXPIRED),
      [STATUS_FAILED]: defaultStatus(STATUS_FAILED),
      [STATUS_PARTIALLY_REFUNDED]: defaultStatus(STATUS_PARTIALLY_REFUNDED),
      [STATUS_PENDING]: defaultStatus(STATUS_PENDING),
      [STATUS_REFUNDED]: defaultStatus(STATUS_REFUNDED),
      [STATUS_REFUSED]: defaultStatus(STATUS_REFUSED),
      [STATUS_SETTLED]: defaultStatus(STATUS_SETTLED),
    },
    [FIELD_NAMES.amountCheckbox]: !!currentFilters.amount,
    [FIELD_NAMES.amount_filter]: currentFilters.amount_filter,
    [FIELD_NAMES.amount]: currentFilters.amount,
    [FIELD_NAMES.fraudCheckbox]: !!(
      currentFilters.fraud_score_min || currentFilters.fraud_score_max
    ),
    [FIELD_NAMES.fraud_score_min]: currentFilters.fraud_score_min,
    [FIELD_NAMES.fraud_score_max]: currentFilters.fraud_score_max,
  };
};

const statusValidation = multiSelectValidation(FIELD_NAMES.statusCheckbox);

const schema = yup.object().shape({
  [FIELD_NAMES.authorized]: statusValidation,
  [FIELD_NAMES.cancelled]: statusValidation,
  [FIELD_NAMES.expired]: statusValidation,
  [FIELD_NAMES.failed]: statusValidation,
  [FIELD_NAMES.partially_refunded]: statusValidation,
  [FIELD_NAMES.pending]: statusValidation,
  [FIELD_NAMES.refunded]: statusValidation,
  [FIELD_NAMES.refused]: statusValidation,
  [FIELD_NAMES.settled]: statusValidation,
  ...amountSchema,
  ...riskScoreSchema,
});

export default schema;
